"use strict";

var _constants = require("../constants");


//////////////////
// WEBPACK FOOTER
// ./node_modules/trezor-connect/lib/types/events.js
// module id = r3Oy
// module chunks = 0